import { ConsumableCadence } from "@/services/backend/qpm/types/enums";

export class ConsumableCadenceUtil {
  private static descriptions: Record<ConsumableCadence, string> = {
    [ConsumableCadence.Never]: "Nie",
    [ConsumableCadence.EveryService]: "Bei jedem Servicetermin",
    [ConsumableCadence.Every2ndService]: "Bei jedem 2. Servicetermin",
    [ConsumableCadence.OncePerYear]: "1× pro Jahr",
  };

  static toLongString(cadence: ConsumableCadence): string {
    return this.descriptions[cadence] || "Unbekannt";
  }
}
